export default "__VITE_ASSET__BctUHH_e__"